<!--
 * @Author: wzh
 * @LastEditTime: 2024-10-14 11:55:48
 * @Description: 账号激活 设置密码
-->
<template>
  <div>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item :label="$t('login.activate.account')">
        <div style="text-align: left">
          <span style="color: var(--primary-color)"> {{ form.username }} </span>
        </div>
      </a-form-model-item>
      <a-form-model-item :label="$t('base.password.new')" prop="password">
        <a-input-password
          :placeholder="$t('base.password.new_placeholder')"
          v-model="form.password"
          :maxLength="32"
        />
        <span class="mm-qd"
          >{{ $t("base.password.strength") }}: {{ strength }}</span
        >
      </a-form-model-item>
      <a-form-model-item
        :label="$t('base.password.new_confirm')"
        prop="password2"
      >
        <a-input-password
          :placeholder="$t('base.password.new_confirm_placeholder')"
          v-model="form.password2"
          :maxLength="32"
        />
      </a-form-model-item>
    </a-form-model>

    <div class="next">
      <a-button
        style="width: 440px"
        type="primary"
        :loading="loading"
        @click="handleNext"
        >{{ $t("base.btn.sure") }}</a-button
      >
    </div>
  </div>
</template>

<script>
import { commonAPI } from "@/apis";

export default {
  /*
  safeParams:{
		业务类型:businessClassify: this.type == "activate" ? "account_active" : this.type == "forget" ? "retrieve_password" : "change_phone_email",
		验证码值:captcha: "",
		邮件还是短信:noticeClassify, 
	}
  */
  props: ["safeParams"],
  data() {
    let validatePass = (rule, value, callback) => {
      if (value != "") {
        let reg1 = escape(value).includes("%u"); // 是否包含中文字符、汉字
        let reg2 = new RegExp(/\s+/g); // 是否包含空格
        if (reg1 || reg2.test(value)) {
          callback(new Error(this.$t("base.password.format_error")));
        }
        if (this.form.password2) {
          this.$refs.form.validateField("password2");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value != "") {
        if (value !== this.form.password) {
          callback(new Error(this.$t("base.password.again_error")));
        } else {
          callback();
        }
      }
    };

    return {
      pswSetInfo: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      form: {
        username: "",
        secretKey: "",
        password: "",
        password2: "",
        passwordStrength: "1",
      },
      rules: {
        password: [
          {
            required: true,
            message: this.$t("base.password.new_placeholder"),
            whitespace: true,
          },
          { validator: validatePass },
        ],
        password2: [
          {
            required: true,
            message: this.$t("base.password.new_confirm_placeholder"),
            whitespace: true,
          },
          { validator: validatePass2 },
        ],
      },
      dissatisfyMsg: "", // 密码强度不满足项
      loading: false,
    };
  },
  computed: {
    // 判断密码强度
    strength() {
      let val = this.form.password;
      if (!val) {
        this.form.passwordStrength = "";
        return "-";
      }
      let length = val.length;
      let obj = this.pswSetInfo;
      let obj2 = this.isNum(val);
      if (
        obj.mmcl == 1 &&
        length >= obj.zlqmmgzcd &&
        obj2.num >= obj.zlqmmgzsl
      ) {
        this.form.passwordStrength = "3";
        return this.$t("base.password.strength_strong");
      }
      if (
        obj.mmcl == 2 &&
        length >= obj.tjqmmgzcd &&
        this.compareMethods(obj2.text, obj.tjqmmgzbh)
      ) {
        this.form.passwordStrength = "3";
        return this.$t("base.password.strength_strong");
      }
      if (
        obj.mmcl == 1 &&
        length >= obj.zlzmmgzcd &&
        obj2.num >= obj.zlzmmgzsl
      ) {
        this.form.passwordStrength = "2";
        return this.$t("base.password.strength_medium");
      }
      if (
        obj.mmcl == 2 &&
        length >= obj.tjzmmgzcd &&
        this.compareMethods(obj2.text, obj.tjzmmgzbh)
      ) {
        this.form.passwordStrength = "2";
        return this.$t("base.password.strength_medium");
      }
      if (
        obj.mmcl == 1 &&
        length >= obj.zlrmmgzcd &&
        obj2.num >= obj.zlrmmgzsl
      ) {
        this.form.passwordStrength = "1";
        return this.$t("base.password.strength_weak");
      }
      if (
        obj.mmcl == 2 &&
        length >= obj.tjrmmgzcd &&
        this.compareMethods(obj2.text, obj.tjrmmgzbh)
      ) {
        this.form.passwordStrength = "1";
        return this.$t("base.password.strength_weak");
      }
      this.form.passwordStrength = "";
      return "-";
    },
  },
  created() {
    // 激活信息
    let obj = JSON.parse(localStorage.getItem("ACTIVATE_INFO"));
    this.form = Object.assign({}, obj);

    this.getPswSet();
  },
  methods: {
    // 获取密码策略
    async getPswSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/pass/get"
      );
      if (code == 0) {
        this.pswSetInfo = { ...data };
      } else {
        this.$message.error(message);
      }
    },
    // 判断包含种类
    isNum(str) {
      let num = 0;
      let arr = [];
      let reg1 = new RegExp(/\d/); // 包含数字
      let reg2 = new RegExp(/[a-z]/); // 包含小写字母
      let reg3 = new RegExp(/[A-Z]/); // 包含大写字母
      if (reg3.test(str)) {
        num = num + 1;
        arr.push("1");
        str = str.replace(/[A-Z]/g, "");
      }
      if (reg2.test(str)) {
        num = num + 1;
        arr.push("2");
        str = str.replace(/[a-z]/g, "");
      }
      if (reg1.test(str)) {
        num = num + 1;
        arr.push("3");
        str = str.replace(/\d/g, "");
      }
      if (str.length) {
        num = num + 1;
        arr.push("4");
      }
      return { num: num, text: arr.join(",") };
    },
    // 指定种类比较
    compareMethods(n, o) {
      let arr1 = n.split(",");
      let arr2 = o.split(",");
      let flag = true;
      let list = [
        this.$t("base.password.capital"),
        this.$t("base.password.lowercase"),
        this.$t("base.password.number"),
        this.$t("base.password.character"),
      ];
      for (let i = 0; i < arr2.length; i++) {
        let item = arr1.find((o) => o == arr2[i]);
        if (!item) {
          flag = false;
          this.dissatisfyMsg = list[arr2[i] - 1];
          break;
        } else {
          this.dissatisfyMsg = "";
        }
      }
      return flag;
    },
    // 下一步
    handleNext() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = this.pswSetInfo;
          let length = this.form.password.length;
          if (obj.mmcl == 1 && length < obj.zlrmmgzcd) {
            this.$message.warning(
              `${this.$t("base.password.length_tip")}: ${obj.zlrmmgzcd}`
            );
            return;
          }
          if (
            obj.mmcl == 2 &&
            (length < obj.tjrmmgzcd || !this.form.passwordStrength)
          ) {
            this.$message.warning(
              `${this.$t("base.password.length_tip")}: ${
                obj.tjrmmgzcd
              },${this.$t("base.pasword.includes_tip")}${this.dissatisfyMsg}`
            );
            return;
          }
          let params = {
            username: this.form.username,
            password: this.form.password,
            secretKey: this.form.secretKey,
            passwordStrength: this.form.passwordStrength,
            ...this.safeParams,
          };
          this.handleNextApi(params);
        } else {
          return false;
        }
      });
    },
    async handleNextApi(params) {
      this.loading = true;
      // "/user/active/changePassword"
      const { code, message } = await commonAPI.postAction(
        "/user/active/changePasswordNew",
        params
      );
      this.loading = false;
      if (code == 0) {
        // this.$message.success(message);
        this.handleSuccess();
      } else {
        this.$message.error(message);
      }
    },
    // 激活成功发通知
    async handleSuccess() {
      this.loading = true;
      const { code, message } = await commonAPI.getAction(
        `/user/active/sendMsg/${this.form.username}?secretKey=${this.form.secretKey}`
      );
      this.loading = false;
      if (code == 0) {
        this.$message.success(message);
        this.$emit("next", 3);
      } else {
        this.$message.error(message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.next {
  text-align: center;
  padding-top: 20px;
}

.mm-qd {
  position: absolute;
  right: 0;
  translate: calc(100% + 10px);
  color: var(--primary-color);
}
</style>
